import type { AdminCompanyVerificationStatus } from '../lib/api';

type Size = 'sm' | 'md' | 'lg';

const SIZE_CLASSES: Record<Size, string> = {
  sm: 'px-1.5 py-0 text-[10px]',
  md: 'px-2 py-0.5 text-xs',
  lg: 'px-3 py-1 text-sm',
};

// 검증 *상태*를 색으로 가르는 범례라 blue 유지 — 상태색은 이번 리스킨 대상이 아니다.
export const VERIFICATION_STATUS_MAP: Record<
  AdminCompanyVerificationStatus,
  { label: string; classes: string }
> = {
  FULLY_VERIFIED: {
    label: '검증 완료',
    classes: 'bg-emerald-100 text-emerald-700',
  },
  STATUS_VERIFIED: {
    label: '번호 확인됨',
    classes: 'bg-blue-100 text-blue-700',
  },
  NOT_APPLICABLE: {
    label: '검증 대상 아님',
    classes: 'bg-gray-100 text-gray-600',
  },
};

export function VerificationBadge({
  status,
  size = 'md',
}: {
  status: AdminCompanyVerificationStatus;
  size?: Size;
}) {
  const { label, classes } = VERIFICATION_STATUS_MAP[status];
  return (
    <span
      className={`inline-flex items-center rounded font-medium ${SIZE_CLASSES[size]} ${classes}`}
    >
      {label}
    </span>
  );
}
